import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { I18nProvider } from "@/lib/i18n";
import Index from "./pages/Index";
import IndexEn from "./pages/IndexEn";
import ContactPopup from "./components/ContactPopup";
import CookieConsent from "./components/CookieConsent";
import SplashScreen from "./components/SplashScreen";
import BackToTop from "./components/BackToTop";

const LazySonner = lazy(() => import("@/components/ui/sonner").then(m => ({ default: m.Toaster })));

const queryClient = new QueryClient();

const AdwarProject = lazy(() => import("./pages/AdwarProject"));
const AqiqProject = lazy(() => import("./pages/AqiqProject"));
const QairawanProject = lazy(() => import("./pages/QairawanProject"));
const NarjisProject = lazy(() => import("./pages/NarjisProject"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const Terms = lazy(() => import("./pages/Terms"));
const BlogPage = lazy(() => import("./pages/BlogPage"));
const ConnectAgent = lazy(() => import("./pages/ConnectAgent"));
const Contact = lazy(() => import("./pages/Contact"));
const ThankYou = lazy(() => import("./pages/ThankYou"));
const NotFound = lazy(() => import("./pages/NotFound"));

const App = () => (
  <HelmetProvider>
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Suspense fallback={null}><LazySonner /></Suspense>
      <I18nProvider>
        <BrowserRouter>
          <SplashScreen />
          <ContactPopup />
          <CookieConsent />
          <BackToTop />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/en" element={<IndexEn />} />
            <Route
              path="/adwar"
              element={
                <Suspense fallback={null}>
                  <AdwarProject />
                </Suspense>
              }
            />
            <Route
              path="/aqiq"
              element={
                <Suspense fallback={null}>
                  <AqiqProject />
                </Suspense>
              }
            />
            <Route
              path="/narjis"
              element={
                <Suspense fallback={null}>
                  <NarjisProject />
                </Suspense>
              }
            />
            <Route
              path="/qairawan"
              element={
                <Suspense fallback={null}>
                  <QairawanProject />
                </Suspense>
              }
            />
            <Route path="/blog" element={<Suspense fallback={null}><BlogPage /></Suspense>} />
            <Route path="/connect" element={<Suspense fallback={null}><ConnectAgent /></Suspense>} />
            <Route path="/contact" element={<Suspense fallback={null}><Contact /></Suspense>} />
            <Route path="/thank-you" element={<Suspense fallback={null}><ThankYou /></Suspense>} />
            <Route path="/privacy" element={<Suspense fallback={null}><PrivacyPolicy /></Suspense>} />
            <Route path="/terms" element={<Suspense fallback={null}><Terms /></Suspense>} />
            <Route path="*" element={<Suspense fallback={null}><NotFound /></Suspense>} />
          </Routes>
        </BrowserRouter>
      </I18nProvider>
    </TooltipProvider>
  </QueryClientProvider>
  </HelmetProvider>
);

export default App;
